<div class="main-wrapper" #mainWrapper>

  <!-- Header section -->
  <!-- <app-header #header *ngIf="showOldHeaderFooter()"></app-header>
  <app-new-homepage-header #header *ngIf="showNewHeaderFooter()"></app-new-homepage-header> -->
<app-header></app-header>
  <!-- Body section -->
  <div [ngStyle]="getActiveClass()">
    <router-outlet></router-outlet>
  </div>

  <!-- loading section -->
  <!-- <block-ui message="Please wait"> -->
  <!-- Markup here -->
  <!-- </block-ui> -->
  <ngx-loading-bar [color]="'orange'" height="4px" [includeSpinner]="false"></ngx-loading-bar>

  <!-- Scroll section -->
  <app-scroll-to-top></app-scroll-to-top>

  <!-- Footer section -->
  <app-footer></app-footer>
  <!-- <app-footer *ngIf="showOldHeaderFooter()"></app-footer> -->
  <!-- <app-new-homepage-footer *ngIf="showNewHeaderFooter()"></app-new-homepage-footer> -->

</div>